export const baseUrls = {
    api: process.env.VUE_APP_API,
    vue: process.env.VUE_APP_LOCAL
};